export const FORM_CONSTANTS = {
  imgDown: '/pub/bus/file/image?fileId=', // å¾çå±ç¤º
  showImage: '/cli/bus/file/image?access_token=', // è¿ééè¦tokenåfileIdä¸¤ä¸ªåæ°
};
export const UPLOAD_TYPES = {
  iconModal: 'iconModal',
  buttonModal: 'buttonModal',
  buttonList: 'buttonList',
  pictureCard: 'pictureCard',
};
